module.exports = __webpack_public_path__ + "static/media/erp-business-6.07b46e58.png";